import React from 'react'
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
} from '@mui/material'
import { GuidanceScriptData } from '@/apps/legacy/features/guidance/types/guidanceTypes'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

type Props = {
  scriptData: GuidanceScriptData
}

const GuidanceScriptTabReadOnly: React.FC<Props> = ({ scriptData }) => {
  // 選択されたスクリプトのみをフィルタリング（displayOrder順）
  const selectedScripts = scriptData.script_items
    .flatMap((item) => item.scripts)
    .filter((script) => script.isSelected)
    .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))

  return (
    <Box>
      {/* 選択されたフレーズエリア */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="subtitle1"
          sx={{
            mb: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          ■ 選択されたフレーズ
          <Chip label={selectedScripts.length} size="small" color="primary" />
        </Typography>

        {selectedScripts.length > 0 ? (
          <Box
            sx={{
              backgroundColor: colorTokens.special.highlight,
              border: `1px solid ${colorTokens.blue[50]}`,
              borderRadius: 1,
              p: 2,
            }}
          >
            <List dense disablePadding>
              {selectedScripts.map((script, index) => (
                <ListItem
                  key={script.id}
                  sx={{
                    py: 0.5,
                    px: 1,
                  }}
                >
                  <ListItemText
                    primary={`${index + 1}. ${script.text}`}
                    primaryTypographyProps={{
                      color: colorTokens.grey[800],
                      lineHeight: 1.6,
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        ) : (
          <Typography
            sx={{
              color: colorTokens.text.secondary,
              backgroundColor: colorTokens.grey[100],
              p: 2,
              borderRadius: 1,
              textAlign: 'center',
            }}
          >
            フレーズが選択されていません
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default GuidanceScriptTabReadOnly
